import "./DotDivider.scss";

import React, { memo } from "react";

const DotDivider: React.FC = memo(() => {
  return <div className="dot-divider" />;
});

export { DotDivider };
